import React from "react";
import ImageGenerator from '../functions/ImageGenerator';

function Image() {
  return (
    <div class="main generate">
      <section class="maintext">
        <ImageGenerator/>
      </section>
      <div className="floating-sidebar">
        <ul>
          <li><a href="/image"><button>Generate</button></a></li>
          <li><a href="/chat"><button>Visit</button></a></li>
          <li><a href="/scenario"><button>Play</button></a></li>
          <li><a href="/challenge"><button>Versus</button></a></li>
        </ul>
      </div>
    </div>
  );
}

export default Image;
